export default "__VITE_ASSET__BRq_vWoT__"